import { format } from "date-fns";
import * as Icons from "heroicons-react";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import {
  useAccountByDateQuery,
  useUpdateAccountDeleteMutation,
} from "../../services/accountApi";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import AccountView from "./AccountView";
import { useSelector } from "react-redux";

const Accounts = () => {
  const auth = signInUser();
  const lang = useSelector((state) => state.languageReducer);

  const { aamarId } = auth || {};
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));

  const { data, isSuccess, refetch } = useAccountByDateQuery(
    {
      startDate,
      endDate,
      aamarId,
    },
    { skip: !aamarId }
  );
  const [deleteUpdateAccount] = useUpdateAccountDeleteMutation();

  let i = 1;

  const [accountId, setAccountId] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleDataLimit = () => {};
  const handleSearch = () => {};
  const deleteHandler = async (e) => {
    const result = await Swal.fire({
      title: "Are you Sure?",
      text: "Delete this Transaction?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      await deleteUpdateAccount({ _id: e })
        .then((res) => {
          notify("Account Deleted Successfully", "success");
          if (refetch) refetch();
        })
        .catch((err) => {
          console.error(err);
          notify("Can not delete account", "error");
        });
    } else {
      notify("Account Delete Canceled", "error");
    }
  };
  useEffect(() => {
    if (aamarId && refetch) {
      refetch();
    }
  }, [startDate, endDate, aamarId]);
  const handleAccountsView = async (e) => {
    setAccountId(e);
    setShow(true);
  };
  return (
    <div>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <div className="row">
              <div className="col-md-12">
                <Header title={lang?.transaction}></Header>
              </div>
              <div className="d-md-flex justify-content-between align-items-center mt-3">
                <div className="date-picker d-flex gap-1 align-items-center">
                  {/* <b>Start:</b> */}
                  <DatePicker
                    selected={new Date(startDate)}
                    className="form-control me-2"
                    onChange={(date) =>
                      setStartDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                  />
                  <span width="10px"></span>
                  {/* <b>End:</b> */}
                  <DatePicker
                    selected={new Date(endDate)}
                    className="form-control"
                    onChange={(date) =>
                      setEndDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                  />
                </div>

                <div className="d-md-flex flex-grow  align-items-center">
                  <div className="d-flex mt-2 mt-md-0">
                    <Link
                      to="/addAfterSale"
                      className="btn btn-dark float-end me-2"
                    >
                      <Icons.Plus className="icon-edit" size={18}></Icons.Plus>
                      {lang?.afterSalePayment}
                    </Link>
                    <Link
                      to="/addAccountExpense"
                      className="btn btn-dark float-end me-2"
                    >
                      <Icons.Plus className="icon-edit" size={18}></Icons.Plus>
                      {lang?.addExpense}
                    </Link>
                  </div>
                  <div className="d-flex mt-2 mt-md-0">
                    <Link
                      to="/addAccount"
                      className="btn btn-dark float-end me-2"
                    >
                      <Icons.Plus className="icon-edit" size={18}></Icons.Plus>
                      {lang?.addPayment}
                    </Link>{" "}
                  </div>
                  {/* <Link to="/acc-report" className="btn btn-dark float-end me-2">
                  <Icons.ChartPieOutline className="icon-edit" size={20} />{" "}
                  Reports
                </Link> */}
                </div>
              </div>
            </div>

            <div
              className="table-responsive mt-2"
              // style={{ maxHeight: "400px", overflowY: "auto" }}
            >
              <table className="table table-striped ">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">AC No</th>
                    <th scope="col">Account Head</th>
                    <th scope="col">Date</th>
                    {/* <th scope="col">Group</th> */}
                    <th scope="col">Amount</th>
                    <th scope="col">Actions </th>
                  </tr>
                </thead>
                <tbody>
                  {/* {isLoading && <h2>...Loading</h2>}
                {isFetching && <h2>...isFetching</h2>}
                {error && <h2>Something went wrong</h2>} */}
                  {data?.length > 0 ? (
                    data?.map((ac) => (
                      <tr key={ac?._id}>
                        <th scope="row">{i++}</th>
                        <td>{ac?.acId}</td>
                        <td>
                          {ac?.accountHead?.name ||
                            ac?.supplier?.company ||
                            ac?.supplier?.name ||
                            ac?.paymentType ||
                            "-"}
                        </td>
                        <td>
                          {format(
                            new Date(ac?.createdAt),
                            "yyyy-MM-dd HH:mm:ss"
                          )}
                        </td>
                        <td>{ac?.amount}</td>
                        <td>
                          <Icons.EyeOutline
                            onClick={() => handleAccountsView(ac._id)}
                            className="icon-eye me-1"
                            size={20}
                            style={{ cursor: "pointer" }}
                          ></Icons.EyeOutline>
                          <Link to={`/account/update/${ac._id}`}>
                            <Icons.PencilAltOutline
                              className="icon-edit me-1"
                              size={20}
                            ></Icons.PencilAltOutline>
                          </Link>
                          <Icons.TrashOutline
                            className="icon-trash"
                            size={20}
                            style={{ cursor: "pointer" }}
                            onClick={() => deleteHandler(ac._id)}
                          ></Icons.TrashOutline>
                        </td>
                      </tr>
                    ))
                  ) : (
                    // <tr>
                    //   <td colSpan={6}>
                    //     {isLoading && <Skeleton count={100} />}
                    //     {/* {isFetching && <h2>...isFetching</h2>}
                    //     {error && <h2>Something went wrong</h2>} */}
                    //   </td>
                    // </tr>
                    <tr colSpan={9}>No Accounts Found</tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <AccountView
        show={show}
        handleClose={handleClose}
        accountId={accountId}
      ></AccountView>
    </div>
  );
};

export default Accounts;
